<template>
    <div id="index" class="index">
        <TheHeaderBar />
        <div class="index-container">
            <TheNavBar />
            <div id="index-content-container" class="index-content-container">
                <div class="index-content">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <!-- <div class="index-container">
            <router-view></router-view>
        </div> -->
    </div>
</template>

<script>
    import TheHeaderBar from '@/components/TheHeader.vue'
    import TheNavBar from '@/components/TheNav.vue'
    const log = new Log("Page/index");
    export default {
        name: "index",
        components: {
            TheNavBar,
            TheHeaderBar,
        },
        created() {
            this.$api.token.check.call(this);
            this.$store.state.main.back = this.$route.meta.back;
            this.$store.state.main.title = this.$route.meta.title;
        },
        watch: {
            $route(to, from) {
                this.$store.state.main.back = to.meta.back;
                this.$store.state.main.title = to.meta.title;
            }
        },
    }
</script>

<style lang="less">
    #index {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        background-color: rgba(240, 242, 245, 1)
    }
    .index-container {
        width: 100%;
        height: ~"calc(100vh - 60px)";
        display: flex;
        position: relative;
    }
    .index-content-container {
        overflow-y: auto;
        height: 100%;
        flex: 1;
        background-color: #eeeeee;
        position: relative;
    }
    .index-content {
        width: 100%;
        min-height: ~"calc(100vh - 60px)";
        padding: 30px;
        background-color: #eeeeee;
    }

    // .index-container {
    //     width: 100%;
    //     height: ~ "calc(100vh - 60px)";
    //     overflow: hidden;
    //     position: relative;
    //     display: flex;
    // }
    // .index-content-container {
    //     flex: 1; 
    //     height: ~ "calc(100vh - 60px)";
    //     position: relative;
    //     overflow-y: auto;
    //     padding: 20px;
    // }
</style>